import React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Formik, Form } from "formik";
import { Box, Button, Heading } from "@chakra-ui/react";
import { ArrowBackIcon } from "@chakra-ui/icons";
import { editStudent, getStudent } from "../../features/students/studentSlice";
import { useLocation } from "react-router-dom";
import { unwrapResult } from "@reduxjs/toolkit";
import Spinner from "../../components/FormElements/Spinner";
import "./EditStudent.css";
import "./RegisterStudent.css";
import StudentFieldSet from "./StudentFieldSet";
import * as Yup from 'yup';
import { SHARED_ROUTES } from "../../config/routes";

const EditStudent = (props) => {
  const location = useLocation();

  //initialise dispatch
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [initialValues, setInitialValues] = useState();
  const [formSubmitted, setFormSubmitted] = useState(false);
  const student_id = location.state.id;

  const handleGoBack = () => {
    navigate(-1);
  };

  const [selectedSchool, setSelectedSchool] = useState(null);
  const [selectedGender, setSelectedGender] = useState(null);

  const handleSelectedSchoolChange = (school) => {
    setSelectedSchool(school);
  };

  const handleSelectedGenderChange = (gender) => {
    setSelectedGender(gender);
  };


  useEffect(() => {
    if (student_id) {
      //get student on load
      dispatch(getStudent(student_id))
        .then((response) => {
          if (response.meta.requestStatus === "fulfilled") {
            return response;
          } else {
            throw response.payload;
          }
        })
        .then(unwrapResult)
        .then((studentResponse) => {
          if (studentResponse.preferred_location_id) {
            setInitialValues({
              ...studentResponse,
              studentEmail: studentResponse.email_address,
              studentName: studentResponse.student_name,
              isConsentGranted: studentResponse.is_consent_granted,
              guardianName: studentResponse.guardian_name,
              iceContactNumber: studentResponse.emergency_contact_number,
              altIceContactNumber: studentResponse.alt_emergency_contact_number,
              medicalConditions: studentResponse.medical_conditions,
              tyInfoSource: studentResponse.ty_info_source,
              isAllowedLDL: studentResponse.is_allowed_leave_during_lunch,
              isAllowedPB: studentResponse.is_allowed_photo_during_training,
              notes: studentResponse.notes,
              school_id: studentResponse.school_id,
              school_name: studentResponse.school_name,
              gender_id: studentResponse.gender_id,
              gender_name: studentResponse.gender_name
            });
            setSelectedSchool(studentResponse.school_id)
            setSelectedGender(studentResponse.gender_id)
          }

          /*setFormData({
            student_id: student_id,
            email_address: studentResponse.email_address,
            student_name: studentResponse.student_name,
            school_id: studentResponse.school_id,
            guardian_email_address: studentResponse.guardian_email_address,
            isConsentGranted: studentResponse.is_consent_granted,
            guardian_name: studentResponse.guardian_name,
            emergency_contact_number: studentResponse.emergency_contact_number,
            alt_emergency_contact_number:
              studentResponse.alt_emergency_contact_number,
            medical_conditions: studentResponse.medical_conditions,
            tyInfoSource: studentResponse.ty_info_source,
            questions: studentResponse.questions,
            isAllowedLDL: studentResponse.is_allowed_leave_during_lunch,
          });*/
        })
        .catch((error) => {
          switch (error.status) {
            case 500 || 401 || 403:
              window.alert("Error: unauthorised to edit student");
              navigate(SHARED_ROUTES.home);
              break;
            default:
              window.alert("Error: failed to load student");
              navigate(SHARED_ROUTES.home);
              break;
          }
        });
    }
  }, []);

  const SignupSchema = Yup.object().shape({
    studentEmail: Yup.string().email('Invalid email').required('Student Email is Required'),
    studentName: Yup.string().required('Student Name is Required'),
    school: Yup.object().nullable().required('School selection is Required'),
    gender: Yup.object().nullable().required('Gender selection is Required'),
    guardian_email_address: Yup.string().email('Invalid email').required('Guardian Email Address is Required'),
    isConsentGranted: Yup.boolean().oneOf([true], 'Consent input is Required'),
    guardianName: Yup.string().required('Guardian Name is Required'),
  });

  const handleSubmitClick = () => {
    setFormSubmitted(true);
  }


  const handleSubmit = (e) => {
    dispatch(editStudent({
      student_id: e.student_id,
      email_address: e.studentEmail,
      student_name: e.studentName,
      school_id: selectedSchool,
      gender_id: selectedGender,
      guardian_email_address: e.guardian_email_address,
      isConsentGranted: e.isConsentGranted,
      guardian_name: e.guardianName,
      emergency_contact_number: e.iceContactNumber,
      alt_emergency_contact_number: e.altIceContactNumber,
      medical_conditions: e.medical_conditions,
      tyInfoSource: e.tyInfoSource,
      questions: e.questions,
      isAllowedLDL: e.isAllowedLDL,
      isAllowedPB: e.isAllowedPB,
      notes: e.notes
    }))
      .then((response) => {
        if (response.meta.requestStatus === "fulfilled") {
          navigate(SHARED_ROUTES.home);
        } else {
          throw response.payload;
        }
      })
      .catch((error) => {
        console.error("Edit student dispatch ", error);
        window.alert("Error updating student information. Please try again");
      });
  };

  return (
    <Box maxWidth="1300px" margin="auto" className="responsive-page-content">
      <div className="return-wrapper">

        <Button as="span" leftIcon={<ArrowBackIcon />} colorScheme="red" variant="link" mb="0.7em" onClick={handleGoBack}>
          Back
        </Button>

      </div>
      <Box bg="white" border="1px solid #edebe9" padding="1em 2.5em">
        <Heading as="h2" size="md" textAlign="center" mb="1.5em" mt="0.5em">
          Student Details
        </Heading>
        {!initialValues ? (
          <Spinner />
        ) : (
          <Formik onSubmit={handleSubmit} id="booking-form" initialValues={initialValues} validationSchema={SignupSchema}>
            {(props) => (
              <Form>
                <StudentFieldSet locationId={initialValues.preferred_location_id} onSelectedGenderChange={handleSelectedGenderChange} selectedGender={initialValues.gender_id} onSelectedSchoolChange={handleSelectedSchoolChange} selectedSchool={initialValues.school_id} formik={props} />
                <Box mt="1.5em" textAlign="center" mb="3em">
                  <Button
                    colorScheme="red"
                    type="submit"
                    width="300px"
                    onClick={handleSubmitClick}
                    isDisabled={!props.isValid}
                  >
                    Save
                  </Button>
                  {/* Show validation errors if form has been submitted and is invalid */}
                  {formSubmitted && !props.isValid && (
                    <Box mt="1em" color="red">
                      Please fill the required fields
                    </Box>
                  )}
                </Box>
              </Form>
            )}
          </Formik>
        )}
      </Box>
    </Box>
  );
};

export default EditStudent;
